import { OptJobType } from 'api/optJobs/optJobs.api'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import { DeepReadonly } from './types'

export function systemFeatureFlagActive(system: DeepReadonly<System> | null, systemFeatureFlag: string): boolean {
  return system?.system_feature_flags?.includes(systemFeatureFlag) || false
}

export function useSystemFeatureFlagIsActive(systemFeatureFlag: string): boolean {
  const { activeSystem } = useAuth()

  return systemFeatureFlagActive(activeSystem, systemFeatureFlag)
}

/**
 * The name the system gives a subtype, falling back to the raw one the backend sent.
 * Null when the queue item or job has no subtype of its own, which is normal — the
 * concept only distinguishes the parallel parts of a multi-subtype job.
 */
export function getSubtypeDisplayName(
  subtype: string | null | undefined,
  availableSubtypes: Subtype[] = []
): string | null {
  const trimmedSubtype = subtype?.trim()
  if (!trimmedSubtype) return null

  return availableSubtypes.find((s) => s.subtype === trimmedSubtype)?.subtype_display_name ?? trimmedSubtype
}

/**
 * The subtypes the active system runs for a job type. `subtypes` is typed as always
 * present, but an activeSystem restored from localStorage by an older app version can
 * predate the field, so a missing map degrades to no display names rather than a crash.
 */
export function useAvailableSubtypes(optJobType: OptJobType): Subtype[] {
  const { activeSystem } = useAuth()

  return activeSystem?.subtypes?.[optJobType] ?? []
}
